/**
 * Locks document scroll on mobile while PDP drawers (Description, Dimensions, etc.)
 * or PDP modals are open. overflow-hidden alone is insufficient on iOS Safari.
 */
(function () {
  let savedScrollY = 0;
  let preventHandler = null;

  const LOCK_CLASS = 'pdp-drawer-open';
  const LOCKED_CLASS = 'is-pdp-drawer-scroll-locked';
  const MOBILE_OVERFLOW_CLASS = 'overflow-hidden-mobile';
  const MOBILE_MQ = '(max-width: 900px)';

  const SCROLLABLE_SELECTORS =
    '.drw-Drawer, .drw-Drawer_Body, .drw-Drawer_Body-Inner, .mod-Modal[aria-expanded="true"], .mod-Modal_Modal, .mod-Modal_Inner, .mod-Modal_Body, .mod-Modal_Content';

  const isMobileViewport = () => window.matchMedia(MOBILE_MQ).matches;

  const isPdpOverlayOpen = () => {
    if (!document.querySelector('product-info, .product')) return false;
    return Boolean(
      document.querySelector('.drw-Drawers.drw-Drawers-active') ||
        document.querySelector('.mod-Modal[aria-expanded="true"]')
    );
  };

  const isScrollAllowedTarget = (target) => Boolean(target?.closest?.(SCROLLABLE_SELECTORS));

  const preventBackgroundScroll = (event) => {
    if (!document.body.classList.contains(LOCK_CLASS)) return;
    if (isScrollAllowedTarget(event.target)) return;
    event.preventDefault();
  };

  const applyLock = () => {
    savedScrollY = window.scrollY;

    document.documentElement.classList.add(LOCK_CLASS, LOCKED_CLASS, MOBILE_OVERFLOW_CLASS);
    document.body.classList.add(LOCK_CLASS, LOCKED_CLASS, MOBILE_OVERFLOW_CLASS);

    document.body.style.setProperty('position', 'fixed', 'important');
    document.body.style.setProperty('top', `-${savedScrollY}px`, 'important');
    document.body.style.setProperty('left', '0', 'important');
    document.body.style.setProperty('right', '0', 'important');
    document.body.style.setProperty('width', '100%', 'important');

    if (!preventHandler) {
      preventHandler = preventBackgroundScroll;
      document.addEventListener('wheel', preventHandler, { passive: false, capture: true });
      document.addEventListener('touchmove', preventHandler, { passive: false, capture: true });
    }

    document.documentElement.dataset.pdpDrawerScrollLocked = 'true';
    document.documentElement.dataset.pdpDrawerScrollY = String(savedScrollY);
  };

  const releaseLock = () => {
    const scrollY = parseInt(
      document.documentElement.dataset.pdpDrawerScrollY || String(savedScrollY),
      10
    );

    document.documentElement.classList.remove(LOCK_CLASS, LOCKED_CLASS, MOBILE_OVERFLOW_CLASS);
    document.body.classList.remove(LOCK_CLASS, LOCKED_CLASS, MOBILE_OVERFLOW_CLASS);

    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('right');
    document.body.style.removeProperty('width');

    if (preventHandler) {
      document.removeEventListener('wheel', preventHandler, { capture: true });
      document.removeEventListener('touchmove', preventHandler, { capture: true });
      preventHandler = null;
    }

    delete document.documentElement.dataset.pdpDrawerScrollLocked;
    delete document.documentElement.dataset.pdpDrawerScrollY;

    window.scrollTo(0, scrollY);
  };

  const syncPdpDrawerScrollLock = (shouldLock) => {
    if (!isMobileViewport()) {
      if (document.documentElement.dataset.pdpDrawerScrollLocked === 'true') releaseLock();
      return;
    }

    const lock = shouldLock === true || (shouldLock !== false && isPdpOverlayOpen());
    const isLocked = document.documentElement.dataset.pdpDrawerScrollLocked === 'true';

    if (lock) {
      if (!isLocked) applyLock();
      return;
    }

    if (isLocked) releaseLock();
  };

  const bindDrawer = (drawer) => {
    if (!drawer || drawer.dataset.pdpScrollLockBound === 'true') return;
    drawer.dataset.pdpScrollLockBound = 'true';
    new MutationObserver(() => syncPdpDrawerScrollLock()).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  const bindModal = (modal) => {
    if (!modal || modal.dataset.pdpScrollLockBound === 'true') return;
    modal.dataset.pdpScrollLockBound = 'true';
    new MutationObserver(() => syncPdpDrawerScrollLock()).observe(modal, {
      attributes: true,
      attributeFilter: ['aria-expanded'],
    });
  };

  const bindAll = () => {
    document.querySelectorAll('.drw-Drawers').forEach(bindDrawer);
    document.querySelectorAll('.mod-Modal').forEach(bindModal);
    syncPdpDrawerScrollLock();
  };

  const initWatchers = () => {
    bindAll();

    const root = document.querySelector('product-info') || document.querySelector('.product');
    if (root) {
      new MutationObserver(bindAll).observe(root, { childList: true, subtree: true });
    }

    window.matchMedia(MOBILE_MQ).addEventListener('change', () => syncPdpDrawerScrollLock());
  };

  window.isPdpOverlayOpen = isPdpOverlayOpen;
  window.syncPdpDrawerScrollLock = syncPdpDrawerScrollLock;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWatchers);
  } else {
    initWatchers();
  }
})();
